function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Layout, Menu, Drawer, Button } from 'antd';
import { XSquareFill, PersonPlusFill, List, EmojiSmileFill } from 'react-bootstrap-icons';
import { Link, Outlet, useNavigate, useParams } from "react-router-dom";
import { Container, Col, Row } from 'react-bootstrap';
import NewCustomer from '../components/forms/NewCustomer';
import UserNavBar from '../components/navbars/UserNavBar';
import Common from '../components/includes/Common';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Header = Layout.Header,
  Content = Layout.Content,
  Footer = Layout.Footer,
  Sider = Layout.Sider;
var Home = function Home() {
  var navigate = useNavigate();
  var _useParams = useParams(),
    userid = _useParams.userid;
  var _useState = useState(Common.currentUser),
    _useState2 = _slicedToArray(_useState, 2),
    user = _useState2[0],
    setUser = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    menuDrawerVisible = _useState4[0],
    setMenuDrawerVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    ncDrawerVisible = _useState6[0],
    setNcDrawerVisible = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    newCustomerCreated = _useState8[0],
    setNewCustomerCreated = _useState8[1];
  var _useState9 = useState(true),
    _useState10 = _slicedToArray(_useState9, 2),
    authProcessing = _useState10[0],
    setAuthProcessing = _useState10[1];
  useEffect(function () {
    var uid = Common.currentUser != null ? Common.currentUser.id : userid;
    axios.post(Common.baseApiUrl + 'authenticateuser', {
      id: uid
    }).then(function (response) {
      setAuthProcessing(false);
      if (response.data.authenticated == true) {
        setUser(response.data.user);
        localStorage.setItem('userData', JSON.stringify(response.data.user));
      } else {
        navigate('/');
      }
    })["catch"](function (error) {});
    if (user == null) {
      setUser(Common.currentUser);
    }
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: user != null ? /*#__PURE__*/_jsxs(Layout, {
      style: {
        minHeight: '100vh'
      },
      children: [/*#__PURE__*/_jsxs(Layout, {
        className: "site-layout",
        children: [/*#__PURE__*/_jsx(Header, {
          className: "site-layout-background",
          style: {
            padding: 0
          },
          children: /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 1,
                md: 1,
                sm: 2,
                xs: 3,
                children: /*#__PURE__*/_jsx("div", {
                  style: {
                    width: '90px'
                  },
                  children: /*#__PURE__*/_jsx("img", {
                    src: "drawables/mvc.jpeg",
                    style: {
                      width: '100%'
                    }
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 1,
                md: 1,
                sm: 1,
                xs: 2,
                children: /*#__PURE__*/_jsx(Button, {
                  type: "default",
                  onClick: function onClick() {
                    setMenuDrawerVisible(true);
                  },
                  children: /*#__PURE__*/_jsx(List, {
                    size: 30
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 1,
                md: 1,
                sm: 2,
                xs: 2,
                children: (Common.currentUser.role == 1 || Common.currentUser.role == 9 || Common.currentUser.role == 6 || Common.currentUser.role == 10) && /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  onClick: function onClick() {
                    setNcDrawerVisible(true);
                  },
                  children: /*#__PURE__*/_jsx(PersonPlusFill, {
                    size: 30
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: {
                  span: 4,
                  offset: 0
                },
                md: {
                  span: 4,
                  offset: 0
                },
                sm: {
                  span: 4,
                  offset: 0
                },
                xs: {
                  span: 5,
                  offset: 0
                },
                children: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(EmojiSmileFill, {
                    size: 25
                  }), " ", user != null && ' ' + user.firstname]
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Content, {
          style: {
            margin: '0 16px'
          },
          children: /*#__PURE__*/_jsx(Outlet, {
            context: [newCustomerCreated, setNewCustomerCreated]
          })
        }), /*#__PURE__*/_jsx(Footer, {
          style: {
            textAlign: 'center'
          },
          children: "Medvie \xA92022 Tous droits r\xE9serv\xE9s"
        })]
      }), /*#__PURE__*/_jsx(Drawer, {
        visible: menuDrawerVisible,
        width: 130,
        closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
          size: 25
        }),
        onClose: function onClose() {
          setMenuDrawerVisible(false);
        },
        closable: true,
        placement: "left",
        children: /*#__PURE__*/_jsx(UserNavBar, {
          handleMenuClose: function handleMenuClose() {
            setMenuDrawerVisible(false);
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        visible: ncDrawerVisible,
        closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
          size: 25
        }),
        headerStyle: {
          background: '#FFDE09'
        },
        width: "95%",
        title: "Nouveau candidat",
        onClose: function onClose() {
          setNcDrawerVisible(false);
        },
        closable: true,
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 4,
              md: 4,
              sm: 8,
              children: /*#__PURE__*/_jsx("div", {
                style: {
                  background: "#EA6A6B",
                  padding: "14px"
                },
                className: "cool-radius",
                children: /*#__PURE__*/_jsx(NewCustomer, {
                  handleUpdate: function handleUpdate() {
                    navigate('/home');
                    setNewCustomerCreated(true);
                  }
                })
              })
            }), /*#__PURE__*/_jsxs(Col, {
              lg: {
                span: 6,
                offset: 2
              },
              md: {
                span: 6,
                offset: 2
              },
              sm: {
                span: 3,
                offset: 1
              },
              children: [/*#__PURE__*/_jsx("img", {
                src: "drawables/homeimg.png",
                style: {
                  width: "100%"
                }
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h1", {
                style: {
                  textAlign: "center",
                  color: "#8291B4",
                  fontWeight: "bold"
                },
                children: "BIENVENUE A MEDVIE"
              })]
            })]
          })
        })
      })]
    }) : /*#__PURE__*/_jsx(_Fragment, {})
  });
};
export default Home;